import { render, staticRenderFns } from "./VmcStaffXmasParty2023.vue?vue&type=template&id=487c1c82&scoped=true"
import script from "./VmcStaffXmasParty2023.vue?vue&type=script&lang=js"
export * from "./VmcStaffXmasParty2023.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c1c82",
  null
  
)

export default component.exports